export const mapWithObjectValues = <T extends {}>(arr: (keyof T)[], obj: T) => {
    return arr.map((key) => obj[key]);
};

export const getArrayOfLength = (length: number, start = 0) => {
    return Array.from({ length }, (_, i) => i + start);
};

type ArrayElement<A> = A extends readonly (infer T)[] ? T : A;

export const getFirstIfArray = <T>(value: T): ArrayElement<T> =>
    Array.isArray(value) ? value[0] : value;
